import api from './'

export default {

    /**
     * Get all notifications
     * @param params
     */
     getAll(params = {}) {
        return api
            .get(`/notifications`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show a notification
     * @param notificationId
     * @param params
     */
     show(notificationId, params) {
        return api
            .get(`/notifications/${notificationId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete a notification
     * @param notificationId
     */
     delete(notificationId) {
        return api
            .delete(`/notifications/${notificationId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Mark a notification as read
     * @param notificationId
     */
     markAsRead(notificationId) {
        return api
            .post(`/notifications/${notificationId}/markAsRead`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Mark a notification as unread
     * @param notificationId
     */
     markAsUnread(notificationId) {
        return api
            .post(`/notifications/${notificationId}/markAsUnread`)
            .then(response => {
                return response.data
            })
    },

}
